import client from "../Client/HttpClient";
import { ISchoolLegalEntityModel } from "@/interfaces/modules";

const ApiPath = "SchoolLegalEntities";

export default {
    GetEntity: (): Promise<ISchoolLegalEntityModel> => client.get(`${ApiPath}`),
    GetById: (id: number): Promise<ISchoolLegalEntityModel> => client.get(`${ApiPath}/${id}`),
    Post: (data: any): Promise<ISchoolLegalEntityModel> => client.post(`${ApiPath}`, data),
};
